export const FACTORY_PURCHASE_AGREEMENT_VERSION = '2026-09-15 V1.0';
export const FACTORY_PURCHASE_AGREEMENT_PATH =
  '/legal/factory-technical-service-purchase-agreement';
